/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IdentityError } from './identityError';


export interface IdentityResult { 
    readonly succeeded?: boolean;
    readonly errors?: Array<IdentityError> | null;
}

